import { InMemoryCache } from '@apollo/client/cache';
import { MockedProvider, MockedProviderProps } from '@apollo/client/testing';

import { chromaticCacheOptions } from './initApollo';

const makeApolloDecorator = (mocks: MockedProviderProps['mocks']) =>
  function getMockedApolloProvider(Story) {
    // provide an InMemoryCache when withCache is true so fields that have merge policies work
    // in stories (ex: App.collaborators, Build.testsGroupedByComponent)
    const cache = new InMemoryCache(chromaticCacheOptions);

    return (
      <MockedProvider mocks={mocks} cache={cache}>
        <Story />
      </MockedProvider>
    );
  };

export default makeApolloDecorator;
